import { PencilSimple, Trash } from '@phosphor-icons/react';

import { Button } from '@/components/ui';

import styles from './PollActions.module.css';

interface PollActionsProps {
    onEdit: () => void;
    onDelete: () => void;
    isDeleting?: boolean;
}

export function PollActions({ onEdit, onDelete, isDeleting = false }: PollActionsProps) {
    return (
        <div className={styles.container}>
            <Button variant="secondary" size="sm" onClick={onEdit} aria-label="Editar encuesta">
                <PencilSimple size={16} />
                Editar
            </Button>
            <Button variant="danger" size="sm" onClick={onDelete} disabled={isDeleting} aria-label="Eliminar encuesta">
                <Trash size={16} />
                Eliminar
            </Button>
        </div>
    );
}
